<script lang="ts">
	import type { HTMLButtonAttributes } from "svelte/elements";
	import { type ButtonSize, type ButtonVariant, getButtonClass } from "./getButtonClass.js";

	const { variant, size, ...rest }: { variant: ButtonVariant; size?: ButtonSize } & HTMLButtonAttributes = $props();
</script>

<button {...rest} class="{getButtonClass(variant, size)} {rest.class}">
	{@render rest.children?.()}
</button>
